module.exports = __webpack_public_path__ + "media/fonts/CourierPrime-Regular-fba4686e.ttf";